import Vue from "vue";
import App from "./App";
import router from "./router";
import "./socket/socket";
import { store } from "./store/store";
import "./directive/index";
import "./registerServiceWorker";

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
